import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { EMPTY_SEARCH_SUGGESTION_QUERY_KEY } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/__internal__/getSearchSuggestionsQueryKey";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
export var useSearchSuggestionsUpdateRecentSearchesQueries = function(action) {
    var queryClient = useQueryClient();
    return useCallback(function(query) {
        queryClient.setQueryData(EMPTY_SEARCH_SUGGESTION_QUERY_KEY, function(oldQueryData) {
            if (oldQueryData === undefined) {
                return oldQueryData;
            }
            var _oldQueryData_recent_searches;
            return ISearchSuggestionResponse.build(_object_spread_props(_object_spread({}, oldQueryData), {
                recent_searches: getUpdatedRecentSearches(action, query, (_oldQueryData_recent_searches = oldQueryData === null || oldQueryData === void 0 ? void 0 : oldQueryData.recent_searches) !== null && _oldQueryData_recent_searches !== void 0 ? _oldQueryData_recent_searches : [])
            }));
        });
        queryClient.invalidateQueries({
            queryKey: EMPTY_SEARCH_SUGGESTION_QUERY_KEY
        });
    }, [
        action,
        queryClient
    ]);
};
var getUpdatedRecentSearches = function(action, query, original) {
    var doesNotMatchQuery = function(originalQuery) {
        return originalQuery !== query;
    };
    if (action === "add") {
        return [
            query
        ].concat(_to_consumable_array(original.filter(doesNotMatchQuery)));
    }
    return original.filter(doesNotMatchQuery);
};
